import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDonordata, fetchcoundata, fetchDocdata, RegisterData } from '../reduxactions/donorrsactions/DProfileAction';
import useEffectOnce from '../hooks/useEffectOnce';
import { InputText } from 'primereact/inputtext';
import { RootState } from '../reducers';
import { Panel } from 'primereact/panel';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchFunddata } from '../reduxactions/fundmanagersactions/FProfileActions';
import { fetchOrgdata } from '../reduxactions/organizationactions/OrgProfileActions';
const Mobprofile = () => {
    const [globalFilter, setGlobalFilter] = useState('')

    const dispatch = useDispatch();
    const { uid } = useParams();
    const { usertype } = useParams();
    console.log("usertype", usertype)
    const data = useSelector((state: RootState) => state.dprofile.data)
    const fdata = useSelector((state: RootState) => state.profiledata.fdata)
    const odata = useSelector((state: RootState) => state.orgpro.odata)

    const [firstname, setfirstName] = useState('');
    const [lastname, setlastName] = useState('');
    const [email, setEmail] = useState('');
    const [gender, setGender] = useState('');
    const [phone, setPhone] = useState<number | any>('');
    const [idcard_no, setIDcard] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [pincode, setPincode] = useState('');
    const [country, setCountry] = useState('');
    const [ffirstname, setffirstName] = useState('');
    const [flastname, setflastName] = useState('');
    const [femail, setfEmail] = useState('');
    const [fgender, setfGender] = useState('');
    const [fphone, setfPhone] = useState<number | any>('');
    const [licenceexpdate, setLicenceexpdate] = useState('');
    const [faddress, setfAddress] = useState('');
    const [nameoforg, setOrgName] = useState('');
    const [nameofperson, setPersonName] = useState('');
    const [oemail, setoEmail] = useState('');
    const [designation, setDesignation] = useState('');
    const [ophone, setoPhone] = useState<number | any>('');
    const [licenseno, setlicenseno] = useState('');
    const [ogrtype, setOrgtype] = useState<string>('');
    const [website, setWebsite] = useState('');
    const [oaddress, setoAddress] = useState('');
    const [ocity, setoCity] = useState('');
    const [ostate, setostate] = useState('');
    const [ocountry, setoCountry] = useState('');
    const [opincode, setoPincode] = useState('');

    const [licenseexpiry, setlicenseexpiry] = useState('');
    const [orgsubtype, setOrgsubtype] = useState<string>('');
    const [paypal, setPaypal] = useState('');
    const [resume, setResume] = useState('');

    useEffect(() => {
        if (data.length > 0) {
            setfirstName(data[0].firstname);
            setlastName(data[0].lastname);
            setEmail(data[0].email);
            setGender(data[0].gender);
            setPhone(data[0].phone);
            setIDcard(data[0].idcard_no);
            setAddress(data[0].address);
            setCity(data[0].city);
            setState(data[0].state);
            setPincode(data[0].pincode);
            setCountry(data[0].country);
        }

    }, [data]);
    useEffect(() => {
        if (fdata.length > 0) {
            setffirstName(fdata[0].firstname);
            setflastName(fdata[0].lastname);
            setfEmail(fdata[0].email);
            setfGender(fdata[0].gender);
            setfPhone(fdata[0].phone);
            setLicenceexpdate(fdata[0].idcard_no);
            setfAddress(fdata[0].address);

        }

    }, [fdata]);
    useEffect(() => {
        if (odata.length > 0) {
            setOrgName(odata[0].nameoforg);
            setPersonName(odata[0].nameofperson);
            setoEmail(odata[0].email);
            setDesignation(odata[0].designation);
            setoPhone(odata[0].phone);
            setlicenseno(odata[0].licenseno);
            setOrgtype(odata[0].ogrtype);
            setWebsite(odata[0].website);
            setoAddress(odata[0].address);
            setoCity(odata[0].city);
            setostate(odata[0].state);
            setoCountry(odata[0].country);
            setoPincode(odata[0].pincode);
            setlicenseexpiry(odata[0].licenseexpiry);
            setOrgsubtype(odata[0].orgsubtype);
            setPaypal(odata[0].paypal);
            setResume(odata[0].resume);

        }

    }, [odata]);
    const handlePhoneChange = (e: any) => {
        const inputPhone = e.target.value;
        // Using regex to keep only digits and limiting to 10 digits
        const formattedPhone = inputPhone.replace(/\D/g, '').slice(0, 10);
        setPhone(formattedPhone);
    };
    const handlefPhoneChange = (e: any) => {
        const inputPhone = e.target.value;
        // Using regex to keep only digits and limiting to 10 digits
        const formattedPhone = inputPhone.replace(/\D/g, '').slice(0, 10);
        setfPhone(formattedPhone);
    };
    const handleoPhoneChange = (e: any) => {
        const inputPhone = e.target.value;
        // Using regex to keep only digits and limiting to 10 digits
        const formattedPhone = inputPhone.replace(/\D/g, '').slice(0, 10);
        setoPhone(formattedPhone);
    };
    //To get profile data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchDonordata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchFundDataAsync = async () => {
        try {
            await dispatch(fetchFunddata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchOrgDataAsync = async () => {
        try {
            await dispatch(fetchOrgdata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsync();
        fetchFundDataAsync();
        fetchOrgDataAsync();
    }, [dispatch]);


    return (
        <div>
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                      
                        {usertype === 'donor' && (
                            <section className="content">
                                {data.map((response: any) =>
                                    <div className="grid" key={response.idcard_no}>
                                        <Card className='border-blue-300 surface-overlay border-3 border-round '>
                                            <Panel header="Profile" toggleable  >
                                                <div className='grid'>
                                                    <div className="col-12">
                                                        <label htmlFor="fname" className="block text-900 font-medium ">First Name</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="fname" type="text" placeholder="Enter First Name" className="w-full mb-3" disabled value={firstname} onChange={(e) => setfirstName(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="lname" className="block text-900 font-medium">Last Name</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="lname" type="text" placeholder="Enter Last Name" className="w-full mb-3" disabled value={lastname} onChange={(e) => setlastName(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="email" className="block text-900 font-medium ">E-mail</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="email" type="text" placeholder="Enter EMAIL" className="w-full mb-3" disabled value={email} onChange={(e) => setEmail(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="email" className="block text-900 font-medium ">Gender</label>

                                                    </div>
                                                    <div className="col-12">
                                                        {/* <Dropdown value={gender} onChange={(e) => setGender(e.target.value)} options={genderoptions} optionLabel="label" optionValue='value' placeholder="Select Gender" className="w-full mb-3" /> */}
                                                        <InputText id="gender" type="text" className="w-full mb-3" disabled value={gender} onChange={(e) => setGender(e.target.value)} />
                                                    </div>


                                                    <div className="col-12">
                                                        <label htmlFor="phone" className="block text-900 font-medium ">Phone Number</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText
                                                            type="tel"
                                                            value={phone}
                                                            onChange={handlePhoneChange}
                                                            placeholder="Enter Phone Number"
                                                            className="w-full mb-3"
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <label htmlFor="cardno" className="block text-900 font-medium ">ID-Card No.</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="cardno" type="text" placeholder="Enter ID-CardNo" className="w-full mb-3" disabled value={idcard_no} onChange={(e) => setIDcard(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="add" className="block text-900 font-medium ">Address</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="add" type="text" placeholder="Enter Address" className="w-full mb-3" disabled value={address} onChange={(e) => setAddress(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="add" className="block text-900 font-medium">City</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="city" type="text" placeholder="Enter City" className="w-full mb-3" disabled value={city} onChange={(e) => setCity(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="state" className="block text-900 font-medium ">State</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="state" type="text" placeholder="Enter State" className="w-full mb-3" disabled value={state} onChange={(e) => setState(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="pincode" className="block text-900 font-medium ">Pin</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="pincode" type="text" placeholder="Enter Pincode" className="w-full mb-3" disabled value={pincode} onChange={(e) => setPincode(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="add" className="block text-900 font-medium">Country</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="city" type="text" placeholder="Enter City" className="w-full mb-3" disabled value={country} onChange={(e) => setCountry(e.target.value)} />
                                                    </div>
                                                </div>
                                            </Panel>
                                        </Card>


                                    </div>
                                )}
                            </section>
                        )}
                        {usertype === 'fundmanager' && (
                            <section className="content">
                                {fdata.map((response: any) =>
                                    <div className="grid" key={response.idcard_no}>
                                        <Card className='border-blue-300 surface-overlay border-3 border-round '>
                                            <Panel header="Profile" toggleable  >
                                                <div className='grid'>
                                                    <div className="col-12">
                                                        <label htmlFor="fname" className="block text-900 font-medium ">First Name</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="fname" type="text" placeholder="Enter First Name" className="w-full mb-3" disabled value={ffirstname} onChange={(e) => setffirstName(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="lname" className="block text-900 font-medium">Last Name</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="lname" type="text" placeholder="Enter Last Name" className="w-full mb-3" disabled value={flastname} onChange={(e) => setflastName(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="email" className="block text-900 font-medium ">E-mail</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="email" type="text" placeholder="Enter EMAIL" className="w-full mb-3" disabled value={femail} onChange={(e) => setfEmail(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="email" className="block text-900 font-medium ">Gender</label>

                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="gender" type="text" className="w-full mb-3" disabled value={fgender} onChange={(e) => setfGender(e.target.value)} />
                                                    </div>
                                                    {/* <div className="col-12">
                                                        <label htmlFor="date" className="block text-900 font-medium ">License Expiry Date</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="email" type="date"
                                                            className="w-full mb-3" value={licenceexpdate} onChange={(e) => setLicenceexpdate(e.target.value)} />
                                                    </div> */}

                                                    <div className="col-12">
                                                        <label htmlFor="phone" className="block text-900 font-medium ">Phone Number</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText
                                                            type="tel"
                                                            value={fphone}
                                                            onChange={handlefPhoneChange}
                                                            placeholder="Enter Phone Number"
                                                            className="w-full mb-3"
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <label htmlFor="add" className="block text-900 font-medium ">Address</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="add" type="text" placeholder="Enter Address" className="w-full mb-3" disabled value={faddress} onChange={(e) => setfAddress(e.target.value)} />
                                                    </div>

                                                </div>
                                            </Panel>
                                        </Card>


                                    </div>
                                )}
                            </section>
                        )}
                        {usertype === 'organisation' && (
                            <section className="content">
                                {odata.map((response: any) =>
                                    <div className="grid" key={response.idcard_no}>
                                        <Card className='border-blue-300 surface-overlay border-3 border-round '>
                                            <Panel header="Profile" toggleable  >
                                                <div className='grid'>
                                                    <div className="col-12">
                                                        <label htmlFor="nameoforg" className="block text-900 font-medium ">Name of The Organization</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="nameoforg" type="text" placeholder="Enter Organization Name" className="w-full mb-3" value={nameoforg} onChange={(e) => setOrgName(e.target.value)} />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="nameofthehead" className="block text-900 font-medium">Name of The Person</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="nameofthehead" type="text" placeholder="Enter First Name" className="w-full mb-3" value={nameofperson} onChange={(e) => setPersonName(e.target.value)} />
                                                    </div>
                                                    <div className="col-4">
                                                        <label htmlFor="email" className="block text-900 font-medium ">Email Address</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="email" type="text" placeholder="Enter EMAIL" className="w-full mb-3" disabled value={oemail} onChange={(e) => setoEmail(e.target.value)} />
                                                    </div>
                                                      <div className="col-12">
                                                        <label htmlFor="designation" className="block text-900 font-medium ">Designation</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="designation" type="text" placeholder="Enter Designation" className="w-full mb-3" value={designation} onChange={(e) => setDesignation(e.target.value)} />
                                                    </div>
                                                    <div className="col-4">
                                                        <label htmlFor="mobile" className="block text-900 font-medium ">Phone Number</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText
                                                            type="tel"
                                                            value={ophone}
                                                            onChange={handleoPhoneChange}
                                                            placeholder="Enter Phone Number"
                                                            className="w-full mb-3"
                                                        />
                                                    </div>
                                                      <div className="col-12">
                                                        <label htmlFor="add" className="block text-900 font-medium ">Address</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="add" type="text" placeholder="Enter Address" className="w-full mb-3" value={oaddress} onChange={(e) => setoAddress(e.target.value)} />
                                                    </div>
                                                      <div className="col-12">
                                                        <label htmlFor="city" className="block text-900 font-medium">City</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="city" type="text" placeholder="Enter City" className="w-full mb-3" value={ocity} onChange={(e) => setoCity(e.target.value)} />
                                                    </div>
                                                      {/* <div className="col-12">
                                                        <label htmlFor="state" className="block text-900 font-medium ">State</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <InputText id="state" type="text" placeholder="Enter State" className="w-full mb-3" value={ostate} onChange={(e) => setostate(e.target.value)} />
                                                    </div> */}

                                                </div>
                                            </Panel>
                                        </Card>


                                    </div>
                                )}
                            </section>
                        )}
                    </div>
                </section>

            </div>
        </div>
    )
}
export default Mobprofile




















